import { createFileRoute } from '@tanstack/react-router'

import { TechnicalError } from '@orus.eu/error'
import { anyOfPermissions } from '@orus.eu/right-access-management'

import { PartnerUserRoutingPage as PartnerUserPage } from '../../../../components/pages/backoffice/partners/partners-user-page.tsx'
import { PlatformUserRoutingPage as PlatformUserPage } from '../../../../components/pages/backoffice/platform/platform-user-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'
import { useBackofficeUser } from '../../../../lib/use-permissions.ts'

export const Route = createFileRoute('/bo/users/$userId')({
  component: function Component() {
    const { userId } = Route.useParams()
    const backofficeUser = useBackofficeUser()

    if (!backofficeUser) {
      throw new TechnicalError('There should have been a backoffice user at this point')
    }

    return (
      <PermissionChecker
        requiredPermissions={[anyOfPermissions('user.read', 'user.read.relatedOnly', 'user.read.allowedOnly')]}
      >
        {backofficeUser.type === 'platform' ? (
          <PlatformUserPage />
        ) : (
          <PartnerUserPage userId={userId} organization={backofficeUser.organization} />
        )}
      </PermissionChecker>
    )
  },
})
